<div class="dashboard-session-status" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="40px">
  <div class="dashboard-session-status__title">
    {{ selectedIntervention?.name }} &nbsp; {{ selectedIntervention?.code }}
  </div>
  <div
    class="dashboard-session-status__controls"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="20px"
  >
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
      <button
        fxFlex="50"
        fxFlex.lt-md="100"
        mat-raised-button
        *ngIf="!selectedIntervention?.startFromPhone"
        [disabled]="!!selectedIntervention?.codeExpired"
        (click)="startRecording()"
      >
        {{ 'Start Recording' | uppercase }}
      </button>
      <button
        fxFlex="50"
        fxFlex.lt-md="100"
        mat-raised-button
        *ngIf="!selectedIntervention?.startFromPhone"
        [disabled]="!!selectedIntervention?.codeExpired"
        (click)="stopRecording()"
      >
        {{ 'Stop Recording' | uppercase }}
      </button>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
      <button
        fxFlex="50"
        fxFlex.lt-md="100"
        mat-raised-button
        (click)="getUploadedFileList()"
        [disabled]="!!selectedIntervention?.codeExpired"
      >
        {{ 'Check Files' | uppercase }}
      </button>
      <button
        fxFlex="50"
        fxFlex.lt-md="100"
        mat-raised-button
        (click)="sessionFinished()"
        [disabled]="!!selectedIntervention?.codeExpired"
      >
        {{ 'Session Finished' | uppercase }}
      </button>
    </div>
  </div>
  <div class="dashboard-session-status__info">
    <span *ngIf="selectedIntervention?.startFromPhone; else recordingStatus">
      Recording controls are on the mobile app.</span
    >
    <ng-template #recordingStatus
      >Recording status: <br />
      <p class="dashboard-session-status__info-message">
        {{ showStatusMessage }}
      </p>
    </ng-template>
  </div>
  <div>
    <div class="dashboard-session-status__info">Device list:</div>
    <div class="dashboard-session-status__items" *ngIf="!devicesArray.length">
      There are no devices for this session.
    </div>
    <form [formGroup]="sessionDeviceForm">
      <div
        formArrayName="devicesArray"
        *ngFor="let device of devicesArray?.controls; let i = index"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
      >
        <mat-card
          class="dashboard-session-status__items"
          [formGroupName]="i"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="space-between start"
        >
          <div (click)="showTagInput(i)" class="dashboard-session-status__items-info" fxFlex="40" fxLayoutGap="10px">
            <span [ngClass]="tagInputIndex === i ? 'dashboard-session-status__items-info--active' : ''">
              {{ device.get('tag').value }}
            </span>
            <input
              matInput
              formControlName="tag"
              [ngClass]="tagInputIndex !== i ? 'dashboard-session-status__items-info--active' : ''"
            />
            <button
              mat-button
              color="primary"
              [ngClass]="tagInputIndex !== i ? 'dashboard-session-status__items-info--active' : ''"
              *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
              (click)="editDeviceTag(i, device.get('key').value)"
              type="submit"
            >
              {{ 'Add tag' | uppercase }}
            </button>
          </div>
          <mat-chip-list fxFlex="20" *ngIf="!selectedIntervention?.startFromPhone">
            <mat-chip>{{ getDeviceStatus(device.get('key').value) | titlecase }}</mat-chip>
          </mat-chip-list>
          <div fxFlex="20">
            <div *ngIf="isFilePresent(device.get('key').value); else notPresent">
              <mat-icon
                matTooltip="Is file present"
                [matTooltipPosition]="'above'"
                class="dashboard-session-status__items-icon"
                >done</mat-icon
              >
            </div>
            <ng-template #notPresent>
              <mat-icon matTooltip="Is file present" [matTooltipPosition]="'above'">cancel</mat-icon>
            </ng-template>
          </div>
          <div *ngIf="!selectedIntervention.startFromPhone" fxFlex="20">
            <mat-checkbox
              formControlName="notUsed"
              dashboardFormControlDisabled
              [disabledControl]="disable"
              (change)="saveUnusedDevice(i, device.get('key').value)"
              >Unuse</mat-checkbox
            >
          </div>
        </mat-card>
      </div>
    </form>
  </div>
</div>
